// ********** privateRouter.jsx **********
// *** autor: W de Paula/MVinfo
// *** data: 05/05/24 - 11:19h
// *** data: 5/7/24 | 11:55h - acrescentado criptografia 
// *** objetivo: tornar privadas rotas que não podem ter acesso comum
// ***
// ********** privateRouter.jsx **********



import { Navigate } from 'react-router-dom'
import { useState } from 'react';
import { decrypt } from '../../Services/cryptoUtils';
import AutoLogout from '../../app/AgendexCliente/components/Login/autologout';

export default function SecureRoute({ children }) {
  const [userObject] = useState(() => {
    const encryptedUser = localStorage.getItem('tokenlg');
    if (encryptedUser) {
        try {
            const decryptedUser = decrypt(encryptedUser);
            return JSON.parse(decryptedUser);
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            return false;
        }
    }
    return false;
  });
  
  const [vLogged ] = useState(() => userObject ? userObject : false);
  
  if (!vLogged) {
    localStorage.clear();
    return <Navigate to="/app/login" replace />
  }

  return (
    <>
      <AutoLogout />
      {children}
    </>
  );
}
